import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'

import { VueEditor } from 'vue2-editor'

export default {
    name: 'PostForm',
    data,
    methods,
    mounted,
    watch,
    components: {
        VueEditor
    }
}
